import { useEffect, useRef, useState } from "react"
import { CalendarEventType, CalendarModuleType } from "../../types/mainModulTypes"
import BaseRichtext from "../common/BaseRichtext"
import BaseSubheadline from "../common/BaseSubheadline"
import Calendar from "react-calendar"
import "react-calendar/dist/Calendar.css"
import { API } from "../../constants/constants"
import { Mousewheel, Navigation } from "swiper/modules"
import { Swiper as SwiperType } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/navigation"
import { findNextDatedCalendarEvent, handleEndDate } from "../../services/functions"
import dayjs from "dayjs"
import { useNavigate } from "react-router-dom"

export default function CalendarComponent(props: CalendarModuleType) {
    const bigswiperRef = useRef<SwiperType>()
    const smallswiperRef = useRef<SwiperType>()
    const [selectCurrentEvent, setselectCurrentEvent] = useState<any | null>(null)

    useEffect(() => {
        const filteredEvents = handleEndDate(props.calenderSelect.content.calenderBlock)
            .filter((event, index, array) => 
                array.findIndex(e => e.calenderArticleHeadline === event.calenderArticleHeadline) === index
            )
        const nextEventIndex = findNextDatedCalendarEvent(filteredEvents)
        goToSlide(nextEventIndex)
    }, [])

    const goToSlide = (index: number) => {
        if (bigswiperRef.current) {
            bigswiperRef.current.slideTo(index)
        }
    }
    
    return (
        <div className="max-w-page mx-auto flex flex-col  items-center">
            {/* CALENDAR PART */}
            <div className="py-24 mb-16 bg-base-100 w-full rounded-default relative">
                {/* CONTENT */}
                <div className="max-w-content mx-auto flex flex-col items-center md:flex-row md:justify-evenly lg:justify-between gap-8 md:gap-4 h-fit md:h-96 px-4">
                    {/* LEFT PART */}
                    <div className="w-full md:w-[30%] flex flex-col gap-4">
                        <BaseSubheadline label={props.calenderSelect?.content?.title} />
                        <BaseRichtext content={props.calenderSelect?.content?.calenderText} classProps="" />
                        {/* TODO Icon einbinden */}
                        <div className="flex flex-wrap flex-col items-start gap-4 md:items-start md:flex-col w-full">
                            <div className="flex gap-4 items-center">
                                <div className="rounded-full h-8 w-8 bg-red-400" />
                                <p className="text-base font-semibold text-red-400">Interne Veranstaltungen</p>
                            </div>
                            <div className="flex gap-4 items-center">
                                <div className="rounded-full h-8 w-8 bg-orange-300" />
                                <p className="text-base font-semibold text-orange-300">Externe Veranstaltungen</p>
                            </div>
                            <div className="flex gap-4 items-center">
                                <div className="rounded-full h-8 w-8 bg-cyan-600" />
                                <p className="text-base font-semibold text-cyan-600">Ausgewählt</p>
                            </div>
                        </div>
                    </div>
                    {/* MIDDLE PART */}
                    <div className="w-48 h-full gap-4 mr-8 hidden lg:flex flex-col items-center">
                        <button
                            onClick={() => {
                                smallswiperRef.current?.slidePrev()
                            }}
                            className="w-0 h-0 border-l-[50px] border-r-[50px] border-b-[30px] border-l-transparent border-r-transparent border-b-base-300 "
                        />
                        <Swiper
                            direction="vertical"
                            slidesPerView={4}
                            mousewheel={true}
                            loop
                            onBeforeInit={(swiper: SwiperType) => {
                                smallswiperRef.current = swiper
                            }}
                            modules={[Navigation, Mousewheel]}
                            className="w-48 h-4/5 gap-2">
                            {handleEndDate(props.calenderSelect.content.calenderBlock)
                                .filter((item, index, array) => 
                                    array.findIndex(event => event.calenderArticleHeadline === item.calenderArticleHeadline) === index
                                )
                                .map((item, index) => (
                                <SwiperSlide key={index} className="!flex">
                                    <SmallEventElement
                                        item={item}
                                        isSelected={selectCurrentEvent?.calenderArticleHeadline === item.calenderArticleHeadline}
                                        selectEvent={() => {
                                            setselectCurrentEvent(item)
                                            const filteredEvents = handleEndDate(props.calenderSelect.content.calenderBlock)
                                                .filter((event, index, array) => 
                                                    array.findIndex(e => e.calenderArticleHeadline === event.calenderArticleHeadline) === index
                                                )
                                            const eventIndex = filteredEvents.findIndex(
                                                (arrayItem) => arrayItem.calenderArticleHeadline === item.calenderArticleHeadline
                                            )
                                            goToSlide(eventIndex)
                                        }}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <button
                            onClick={() => {
                                smallswiperRef.current?.slideNext()
                            }}
                            className="w-0 h-0 border-l-[50px] border-r-[50px] border-t-[30px] border-l-transparent border-r-transparent border-t-base-300"></button>
                    </div>
                    {/* RIGHT PART */}
                    <div className="my-auto">
                        <Calendar
                            onClickDay={(date) => {
                                const lookForEventOnDate = handleEndDate(props.calenderSelect.content.calenderBlock).findIndex(
                                    (item) => item.calenderArticleDate === dayjs(date).format("YYYY-MM-DD")
                                )
                                if (lookForEventOnDate !== -1) {
                                    goToSlide(lookForEventOnDate)
                                }
                            }}
                            tileContent={({ date, view }) => {
                                if (view !== "month") return null

                                // Ensure the date is in 'YYYY-MM-DD' format without time zone offsets
                                const formattedDate = date.toISOString()?.split("T")[0]
                                const eventsOfDate = handleEndDate(props.calenderSelect.content.calenderBlock).filter(
                                    (event) => event.calenderArticleDate === dayjs(formattedDate).add(1, "day").format("YYYY-MM-DD")
                                )

                                return eventsOfDate.length > 0 ? (
                                    <div className={`flex justify-center items-center relative pt-1 w-full`}>
                                        <div
                                            className={`absolute h-3 w-3 ${eventsOfDate.length === 2 && "left-2"} rounded-full ${
                                                selectCurrentEvent === eventsOfDate[0]
                                                    ? "bg-cyan-600"
                                                    : eventsOfDate[0]?.calenderArticleCategory === "calenderArticleCategoryExtern"
                                                    ? "bg-orange-300"
                                                    : "bg-red-300"
                                            }`}></div>
                                        <div
                                            className={`absolute h-3 w-3 ${eventsOfDate.length === 2 ? "right-2" : "hidden"} rounded-full ${
                                                selectCurrentEvent === eventsOfDate[1]
                                                    ? "bg-cyan-600"
                                                    : eventsOfDate[1]?.calenderArticleCategory === "calenderArticleCategoryExtern"
                                                    ? "bg-orange-300"
                                                    : "bg-red-300"
                                            }`}></div>
                                    </div>
                                ) : null
                            }}
                            tileClassName={({ date, view }) => {
                                if (view === "month") {
                                    // Highlight today's date
                                    if (date.toDateString() === new Date().toDateString()) {
                                        return "!text-base !bg-white !font-bold hover:!bg-white/80"
                                    }
                                }
                                return null
                            }}
                            className={"!border-2 !rounded-default"}
                        />
                    </div>
                </div>
                {/* TRIANGLE */}
                <div className="hidden md:block w-0 h-0 border-l-[40px] border-r-[40px] border-t-[70px] border-l-transparent border-r-transparent border-t-base-100 absolute -bottom-16 right-48"></div>
            </div>

            {/* SLIDER */}
            <div className="w-full flex max-w-content justify-center relative items-center px-4 pb-16 sm:pb-8 md:pb-0">
                <button
                    onClick={() => {
                        bigswiperRef.current?.slidePrev()
                    }}
                    className={`w-0 h-0 border-t-[50px] border-l-base-300 border-t-transparent border-b-[50px] border-b-transparent border-l-[30px] rotate-180`}
                />
                <Swiper
                    slidesPerView={1}
                    spaceBetween={50}
                    modules={[Navigation]}
                    loop
                    onBeforeInit={(swiper: SwiperType) => {
                        bigswiperRef.current = swiper
                    }}
                    onSlideChange={(swiper: SwiperType) => {
                        const filteredEvents = handleEndDate(props.calenderSelect.content.calenderBlock)
                            .filter((event, index, array) => 
                                array.findIndex(e => e.calenderArticleHeadline === event.calenderArticleHeadline) === index
                            )
                        setselectCurrentEvent(filteredEvents[swiper.activeIndex])
                    }}>

                    {handleEndDate(props.calenderSelect.content.calenderBlock)
                        .filter((item, index, array) => 
                            array.findIndex(event => event.calenderArticleHeadline === item.calenderArticleHeadline) === index
                        )
                        .map((item, index) => (
                        <SwiperSlide key={index} className=" !flex items-center justify-center my-auto">
                            <DetailEvent item={item} isSelected={selectCurrentEvent?.calenderArticleHeadline === item.calenderArticleHeadline} />
                        </SwiperSlide>
                    ))}
                </Swiper>

                <button
                    onClick={() => {
                        bigswiperRef.current?.slideNext()
                    }}
                    className={`w-0 h-0 border-t-[50px] border-l-base-300 border-t-transparent border-b-[50px] border-b-transparent border-l-[30px] 
`}
                />
            </div>
        </div>
    )
}

type SmallEventElementType = {
    item: CalendarEventType
    selectEvent?: () => void
    isSelected?: boolean
}

function SmallEventElement(props: SmallEventElementType) {
    return (
        <div
            onClick={props.selectEvent}
            className={`truncate border-2 rounded-default w-full flex items-center justify-center my-2 bg-accent cursor-pointer ${
                props.isSelected ? "border-cyan-600" : ""
            }`}>
            {props.item.calenderArticleHeadline}
        </div>
    )
}

function DetailEvent(props: SmallEventElementType) {
    const navigate = useNavigate()
    return (
        <div className="w-4/5 h-fit flex flex-col-reverse md:flex-row gap-8 justify-center items-center ">
            <div className="w-full md:w-1/2 flex items-center justify-center ">
                <img
                    className="w-full md:w-4/5 aspect-auto rounded-default object-cover h-64 "
                    src={API + props.item.calenderArticleImage.url}
                    alt={props.item.calenderArticleImage.description ?? props.item.calenderArticleImage.name}
                />
            </div>
            <div className="w-full md:w-1/2 my-auto ">
                <p className="">{dayjs(props.item.calenderArticleDate).format("DD.MM.YYYY")}</p>
                <BaseSubheadline label={props.item.calenderArticleHeadline} />
                <BaseRichtext content={props.item.calenderArticleText} classProps="line-clamp-6 lg:line-clamp-[10]" />
                <button className="text-sm text-primary" onClick={() => navigate("/blog?eintrag=" + encodeURIComponent(JSON.stringify(props.item)))}>
                    <p>mehr erfahren...</p>
                </button>
            </div>
        </div>
    )
}
